// extracted by mini-css-extract-plugin
export default {"container":"Controls_container__iOHCv","button":"Controls_button__2agRo","large":"Controls_large__j+e0Q","active":"Controls_active__8i1ky"};